import { action, computed, observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {Employee} from 'main/stores/employees';
import {calendarDate} from 'shared/tools';
import _ from 'lodash';

class CheckIn extends DomainObject {
  answers = [];
  completedAt;
  createdAt;
  reviewerNotes;
  sharedReviewerNotes;
  reviewer;

  _relations = {
    reviewer: Employee,
    _dates: ['createdAt', 'completedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      answers: observable,
      completedAt: observable,
      createdAt: observable,
      reviewerNotes: observable,
      sharedReviewerNotes: observable,
      reviewer: observable,
      date: computed,
      completed: computed,
      canComplete: computed,
      canUncomplete: computed,
      regenerateAnswersForQuestions: action
    });

    this.merge(other);
  }

  get date() {
    return calendarDate(this.createdAt);
  }

  get completed() {
    return !!this.completedAt;
  }

  get canComplete() {
    return this.hasLink('complete');
  }

  get canUncomplete() {
    return this.hasLink('uncomplete');
  }

  _afterMerge() {
    this.answers = _.orderBy(this.answers, 'question.order');
  }

  regenerateAnswersForQuestions(questions) {
    let newAnswers = [];
    let currentAnswers = _.keyBy(this.answers, 'question.id');

    _.forEach(questions, q => {
      let answer = {question: q};
      if (currentAnswers[q.id] !== undefined) {
        answer.content = currentAnswers[q.id].content;
      }
      newAnswers.push(answer);
    });

    this.answers = newAnswers;
  }
}

export default CheckIn;
